import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=2ec76d66&scoped=true&"
import script from "./ButtonLink.vue?vue&type=script&lang=ts&"
export * from "./ButtonLink.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=2ec76d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec76d66",
  null
  
)

export default component.exports